/* eslint-disable */
// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,add_pb_suffix,ts_nocheck,eslint_disable
// @generated from protobuf file "llm/models.proto" (package "rd.llm", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { Money } from "../proto/money/models_pb";
import { Timestamp } from "../google/protobuf/timestamp_pb";
import { UUID } from "../proto/uuid/models_pb";
/**
 * Conversation represents a conversation between a user and LLM (Dooey).
 *
 * @generated from protobuf message rd.llm.Conversation
 */
export interface Conversation {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID company_id = 2
     */
    companyId?: UUID;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 3
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 4
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID user_id = 5
     */
    userId?: UUID;
    /**
     * @generated from protobuf field: repeated rd.llm.Message messages = 6
     */
    messages: Message[];
    /**
     * @generated from protobuf field: string name = 7
     */
    name: string;
    /**
     * @generated from protobuf field: rd.llm.Conversation.ExternalConversation external_conversation = 8
     */
    externalConversation?: Conversation_ExternalConversation;
    /**
     * @generated from protobuf field: rd.llm.Conversation.Type type = 9
     */
    type: Conversation_Type;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID routine_id = 10
     */
    routineId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID source_conversation_id = 11
     */
    sourceConversationId?: UUID;
    /**
     * @generated from protobuf field: rd.llm.Usage total_usage = 12
     */
    totalUsage?: Usage;
}
/**
 * @generated from protobuf message rd.llm.Conversation.ExternalConversation
 */
export interface Conversation_ExternalConversation {
    /**
     * @generated from protobuf field: string external_conversation_id = 1
     */
    externalConversationId: string; // This should be updated whenever a new external
    /**
     * @generated from protobuf field: rd.llm.Conversation.ExternalConversation.Status status = 2
     */
    status: Conversation_ExternalConversation_Status;
    /**
     * @generated from protobuf field: string sse_url = 3
     */
    sseUrl: string;
}
/**
 * conversation is started in the conversation
 *
 * @generated from protobuf enum rd.llm.Conversation.ExternalConversation.Status
 */
export enum Conversation_ExternalConversation_Status {
    /**
     * @generated from protobuf enum value: STATUS_UNDEFINED = 0;
     */
    UNDEFINED = 0,
    /**
     * @generated from protobuf enum value: STATUS_IN_PROGRESS = 1;
     */
    IN_PROGRESS = 1,
    /**
     * @generated from protobuf enum value: STATUS_ESCALATED = 2;
     */
    ESCALATED = 2,
    /**
     * @generated from protobuf enum value: STATUS_RESOLVED = 3;
     */
    RESOLVED = 3
}
/**
 * @generated from protobuf enum rd.llm.Conversation.Type
 */
export enum Conversation_Type {
    /**
     * @generated from protobuf enum value: TYPE_UNDEFINED = 0;
     */
    UNDEFINED = 0,
    /**
     * @generated from protobuf enum value: TYPE_DEFAULT = 1;
     */
    DEFAULT = 1,
    /**
     * @generated from protobuf enum value: TYPE_DAILY_SUMMARY = 2;
     */
    DAILY_SUMMARY = 2,
    /**
     * @generated from protobuf enum value: TYPE_COPIED_DAILY_SUMMARY = 3;
     */
    COPIED_DAILY_SUMMARY = 3,
    /**
     * @generated from protobuf enum value: TYPE_ORDER = 4;
     */
    ORDER = 4,
    /**
     * @generated from protobuf enum value: TYPE_REPORT = 5;
     */
    REPORT = 5,
    /**
     * @generated from protobuf enum value: TYPE_GENERAL = 6;
     */
    GENERAL = 6
}
/**
 * Usage captures LLM token usage reported by the provider. Input tokens are
 * split into uncached, cache-write, and cache-read buckets since they are
 * billed at different rates. The cache_creation breakdown is populated when
 * using the extended-TTL cache beta.
 *
 * @generated from protobuf message rd.llm.Usage
 */
export interface Usage {
    /**
     * @generated from protobuf field: int64 input_tokens = 1
     */
    inputTokens: bigint;
    /**
     * @generated from protobuf field: int64 output_tokens = 2
     */
    outputTokens: bigint;
    /**
     * @generated from protobuf field: int64 cache_creation_input_tokens = 3
     */
    cacheCreationInputTokens: bigint;
    /**
     * @generated from protobuf field: int64 cache_read_input_tokens = 4
     */
    cacheReadInputTokens: bigint;
    /**
     * @generated from protobuf field: rd.llm.Usage.CacheCreation cache_creation = 5
     */
    cacheCreation?: Usage_CacheCreation;
}
/**
 * @generated from protobuf message rd.llm.Usage.CacheCreation
 */
export interface Usage_CacheCreation {
    /**
     * @generated from protobuf field: int64 ephemeral_5m_input_tokens = 1
     */
    ephemeral5MInputTokens: bigint;
    /**
     * @generated from protobuf field: int64 ephemeral_1h_input_tokens = 2
     */
    ephemeral1HInputTokens: bigint;
}
/**
 * Message represents a "turn" of dialogue in a Conversation: user, agent,
 * user, agent, etc. A Message comprises one or more Blocks, which can be
 * different content types (text, image, etc.).
 *
 * @generated from protobuf message rd.llm.Message
 */
export interface Message {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: rd.llm.Message.Role role = 2
     */
    role: Message_Role;
    /**
     * @generated from protobuf field: repeated rd.llm.Message.Block blocks = 3
     */
    blocks: Message_Block[];
    /**
     * @generated from protobuf field: rd.llm.Message.Status status = 4
     */
    status: Message_Status;
    /**
     * AppContext stores the UserAppContext at the time the prompt request was made.
     *
     * @generated from protobuf field: rd.llm.UserAppContext app_context = 5
     */
    appContext?: UserAppContext;
    /**
     * @generated from protobuf field: rd.llm.Message.Container container = 6
     */
    container?: Message_Container;
    /**
     * usage captures the token usage for generating this Message.
     * this will be cumulative across the whole response.
     *
     * @generated from protobuf field: rd.llm.Usage usage = 7
     */
    usage?: Usage;
    /**
     * feedback captures thumbs up/down feedback a user left on an agent message.
     *
     * @generated from protobuf field: rd.llm.Message.Feedback feedback = 8
     */
    feedback?: Message_Feedback;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 9
     */
    createdAt?: Timestamp;
}
/**
 * @generated from protobuf message rd.llm.Message.Block
 */
export interface Message_Block {
    /**
     * @generated from protobuf field: rd.llm.Message.Block.Type type = 1
     */
    type: Message_Block_Type;
    /**
     * @generated from protobuf field: bytes content = 2
     */
    content: Uint8Array;
    /**
     * @generated from protobuf field: string content_string = 3
     */
    contentString: string;
    /**
     * @generated from protobuf field: rd.llm.Message.Block.ToolRequest tool_request = 4
     */
    toolRequest?: Message_Block_ToolRequest;
    /**
     * @generated from protobuf field: rd.llm.Message.Block.ToolResponse tool_response = 5
     */
    toolResponse?: Message_Block_ToolResponse;
    /**
     * @generated from protobuf field: rd.llm.Message.Block.Audio audio = 6
     */
    audio?: Message_Block_Audio;
    /**
     * @generated from protobuf field: rd.llm.Message.Block.Image image = 7
     */
    image?: Message_Block_Image;
    /**
     * @generated from protobuf field: rd.llm.Message.Block.Document document = 8
     */
    document?: Message_Block_Document;
    /**
     * @generated from protobuf field: rd.llm.Message.Block.ServerToolRequest server_tool_request = 9
     */
    serverToolRequest?: Message_Block_ServerToolRequest;
    /**
     * @generated from protobuf field: rd.llm.Message.Block.ServerToolResponse server_tool_response = 10
     */
    serverToolResponse?: Message_Block_ServerToolResponse;
    /**
     * @generated from protobuf field: rd.llm.Message.Block.Draft draft = 11
     */
    draft?: Message_Block_Draft;
    /**
     * @generated from protobuf field: rd.llm.Message.Block.MCPToolRequest mcp_tool_request = 12
     */
    mcpToolRequest?: Message_Block_MCPToolRequest;
    /**
     * @generated from protobuf field: rd.llm.Message.Block.MCPToolResponse mcp_tool_response = 13
     */
    mcpToolResponse?: Message_Block_MCPToolResponse;
    /**
     * @generated from protobuf field: rd.llm.Message.Block.Thinking thinking = 14
     */
    thinking?: Message_Block_Thinking;
}
/**
 * @generated from protobuf message rd.llm.Message.Block.ToolRequest
 */
export interface Message_Block_ToolRequest {
    /**
     * @generated from protobuf field: string tool_name = 1
     */
    toolName: string;
    /**
     * @generated from protobuf field: bytes input_json = 2
     */
    inputJson: Uint8Array;
    /**
     * @generated from protobuf field: string external_id = 3
     */
    externalId: string;
    /**
     * external_caller_tool_request_id is set when this tool was invoked
     * programmatically from inside a server-side tool (e.g. a code_execution
     * sandbox); it references the calling server_tool_use external_id.
     * Empty for direct, model-initiated calls.
     *
     * @generated from protobuf field: string external_caller_tool_request_id = 4
     */
    externalCallerToolRequestId: string;
}
/**
 * @generated from protobuf message rd.llm.Message.Block.ToolResponse
 */
export interface Message_Block_ToolResponse {
    /**
     * @generated from protobuf field: string tool_name = 1
     */
    toolName: string;
    /**
     * @generated from protobuf field: string output = 2
     */
    output: string;
    /**
     * @generated from protobuf field: string error = 3
     */
    error: string;
    /**
     * @generated from protobuf field: string external_id = 4
     */
    externalId: string;
}
/**
 * @generated from protobuf message rd.llm.Message.Block.Audio
 */
export interface Message_Block_Audio {
    /**
     * @generated from protobuf field: string mime_type = 1
     */
    mimeType: string;
    /**
     * @generated from protobuf field: bytes data = 2
     */
    data: Uint8Array;
}
/**
 * @generated from protobuf message rd.llm.Message.Block.Image
 */
export interface Message_Block_Image {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID attachment_id = 1
     */
    attachmentId?: UUID;
    /**
     * @generated from protobuf field: string external_id = 2
     */
    externalId: string;
    /**
     * @generated from protobuf field: string name = 3
     */
    name: string;
    /**
     * @generated from protobuf field: string mime_type = 4
     */
    mimeType: string;
}
/**
 * @generated from protobuf message rd.llm.Message.Block.Document
 */
export interface Message_Block_Document {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID attachment_id = 1
     */
    attachmentId?: UUID;
    /**
     * @generated from protobuf field: string external_id = 2
     */
    externalId: string;
    /**
     * @generated from protobuf field: string name = 3
     */
    name: string;
    /**
     * @generated from protobuf field: string mime_type = 4
     */
    mimeType: string;
}
/**
 * @generated from protobuf message rd.llm.Message.Block.ServerToolRequest
 */
export interface Message_Block_ServerToolRequest {
    /**
     * @generated from protobuf field: string tool_name = 1
     */
    toolName: string;
    /**
     * @generated from protobuf field: bytes input_json = 2
     */
    inputJson: Uint8Array;
    /**
     * @generated from protobuf field: string external_id = 3
     */
    externalId: string;
}
/**
 * @generated from protobuf message rd.llm.Message.Block.ServerToolResponse
 */
export interface Message_Block_ServerToolResponse {
    /**
     * @generated from protobuf field: string tool_name = 1
     */
    toolName: string;
    /**
     * @generated from protobuf field: string external_id = 2
     */
    externalId: string;
    /**
     * @generated from protobuf field: repeated rd.llm.Message.Block.ServerToolResponse.File files = 3
     */
    files: Message_Block_ServerToolResponse_File[];
}
/**
 * @generated from protobuf message rd.llm.Message.Block.ServerToolResponse.File
 */
export interface Message_Block_ServerToolResponse_File {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID attachment_id = 1
     */
    attachmentId?: UUID;
    /**
     * @generated from protobuf field: string external_id = 2
     */
    externalId: string;
}
/**
 * @generated from protobuf message rd.llm.Message.Block.Draft
 */
export interface Message_Block_Draft {
    /**
     * @generated from protobuf field: rd.llm.Message.Block.Draft.ReviewStatus review_status = 1
     */
    reviewStatus: Message_Block_Draft_ReviewStatus;
}
/**
 * @generated from protobuf enum rd.llm.Message.Block.Draft.ReviewStatus
 */
export enum Message_Block_Draft_ReviewStatus {
    /**
     * @generated from protobuf enum value: REVIEW_STATUS_NONE = 0;
     */
    NONE = 0,
    /**
     * @generated from protobuf enum value: REVIEW_STATUS_ACCEPTED = 1;
     */
    ACCEPTED = 1,
    /**
     * @generated from protobuf enum value: REVIEW_STATUS_REJECTED = 2;
     */
    REJECTED = 2
}
/**
 * @generated from protobuf message rd.llm.Message.Block.MCPToolRequest
 */
export interface Message_Block_MCPToolRequest {
    /**
     * @generated from protobuf field: string tool_name = 1
     */
    toolName: string;
    /**
     * @generated from protobuf field: bytes input_json = 2
     */
    inputJson: Uint8Array;
    /**
     * @generated from protobuf field: string external_id = 3
     */
    externalId: string;
    /**
     * @generated from protobuf field: string mcp_server_name = 4
     */
    mcpServerName: string;
}
/**
 * @generated from protobuf message rd.llm.Message.Block.MCPToolResponse
 */
export interface Message_Block_MCPToolResponse {
    /**
     * @generated from protobuf field: string tool_name = 1
     */
    toolName: string;
    /**
     * @generated from protobuf field: string external_id = 2
     */
    externalId: string;
    /**
     * @generated from protobuf field: string error = 3
     */
    error: string;
}
/**
 * @generated from protobuf message rd.llm.Message.Block.Thinking
 */
export interface Message_Block_Thinking {
    /**
     * @generated from protobuf field: string signature = 1
     */
    signature: string;
}
/**
 * @generated from protobuf enum rd.llm.Message.Block.Type
 */
export enum Message_Block_Type {
    /**
     * @generated from protobuf enum value: TYPE_UNDEFINED = 0;
     */
    UNDEFINED = 0,
    /**
     * @generated from protobuf enum value: TYPE_TEXT = 1;
     */
    TEXT = 1,
    /**
     * @generated from protobuf enum value: TYPE_THINKING = 2;
     */
    THINKING = 2,
    /**
     * @generated from protobuf enum value: TYPE_TOOL_REQUEST = 3;
     */
    TOOL_REQUEST = 3,
    /**
     * @generated from protobuf enum value: TYPE_TOOL_RESPONSE = 4;
     */
    TOOL_RESPONSE = 4,
    /**
     * @generated from protobuf enum value: TYPE_AUDIO = 5;
     */
    AUDIO = 5,
    /**
     * @generated from protobuf enum value: TYPE_IMAGE = 6;
     */
    IMAGE = 6,
    /**
     * @generated from protobuf enum value: TYPE_DOCUMENT = 7;
     */
    DOCUMENT = 7,
    /**
     * @generated from protobuf enum value: TYPE_SERVER_TOOL_REQUEST = 8;
     */
    SERVER_TOOL_REQUEST = 8,
    /**
     * @generated from protobuf enum value: TYPE_SERVER_TOOL_RESPONSE = 9;
     */
    SERVER_TOOL_RESPONSE = 9,
    /**
     * @generated from protobuf enum value: TYPE_DRAFT = 10;
     */
    DRAFT = 10,
    /**
     * @generated from protobuf enum value: TYPE_COMPACTION = 12;
     */
    COMPACTION = 12,
    /**
     * @generated from protobuf enum value: TYPE_MCP_TOOL_REQUEST = 13;
     */
    MCP_TOOL_REQUEST = 13,
    /**
     * @generated from protobuf enum value: TYPE_MCP_TOOL_RESPONSE = 14;
     */
    MCP_TOOL_RESPONSE = 14,
    /**
     * @generated from protobuf enum value: TYPE_REDACTED_THINKING = 15;
     */
    REDACTED_THINKING = 15
}
/**
 * @generated from protobuf message rd.llm.Message.Container
 */
export interface Message_Container {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp expires_at = 2
     */
    expiresAt?: Timestamp;
}
/**
 * @generated from protobuf message rd.llm.Message.Feedback
 */
export interface Message_Feedback {
    /**
     * @generated from protobuf field: rd.llm.Message.Feedback.Sentiment sentiment = 1
     */
    sentiment: Message_Feedback_Sentiment;
    /**
     * @generated from protobuf field: string comment = 2
     */
    comment: string;
    /**
     * reason is only set for negative feedback.
     *
     * @generated from protobuf field: rd.llm.Message.Feedback.Reason reason = 3
     */
    reason: Message_Feedback_Reason;
}
/**
 * @generated from protobuf enum rd.llm.Message.Feedback.Sentiment
 */
export enum Message_Feedback_Sentiment {
    /**
     * @generated from protobuf enum value: SENTIMENT_NONE = 0;
     */
    NONE = 0,
    /**
     * @generated from protobuf enum value: SENTIMENT_POSITIVE = 1;
     */
    POSITIVE = 1,
    /**
     * @generated from protobuf enum value: SENTIMENT_NEGATIVE = 2;
     */
    NEGATIVE = 2
}
/**
 * @generated from protobuf enum rd.llm.Message.Feedback.Reason
 */
export enum Message_Feedback_Reason {
    /**
     * @generated from protobuf enum value: REASON_NONE = 0;
     */
    NONE = 0,
    /**
     * @generated from protobuf enum value: REASON_INCORRECT = 1;
     */
    INCORRECT = 1,
    /**
     * @generated from protobuf enum value: REASON_INCOMPLETE = 2;
     */
    INCOMPLETE = 2,
    /**
     * @generated from protobuf enum value: REASON_DID_NOT_FOLLOW_INSTRUCTIONS = 3;
     */
    DID_NOT_FOLLOW_INSTRUCTIONS = 3,
    /**
     * @generated from protobuf enum value: REASON_OTHER = 4;
     */
    OTHER = 4
}
/**
 * @generated from protobuf enum rd.llm.Message.Role
 */
export enum Message_Role {
    /**
     * @generated from protobuf enum value: ROLE_UNDEFINED = 0;
     */
    UNDEFINED = 0,
    /**
     * @generated from protobuf enum value: ROLE_USER = 1;
     */
    USER = 1,
    /**
     * @generated from protobuf enum value: ROLE_AGENT = 2;
     */
    AGENT = 2
}
/**
 * @generated from protobuf enum rd.llm.Message.Status
 */
export enum Message_Status {
    /**
     * @generated from protobuf enum value: STATUS_NONE = 0;
     */
    NONE = 0,
    /**
     * @generated from protobuf enum value: STATUS_PENDING = 1;
     */
    PENDING = 1,
    /**
     * @generated from protobuf enum value: STATUS_IN_PROGRESS = 2;
     */
    IN_PROGRESS = 2,
    /**
     * @generated from protobuf enum value: STATUS_TIMED_OUT = 3;
     */
    TIMED_OUT = 3
}
/**
 * Fragment is a partial Message Block. These are returned by the client when
 * streaming responses from the API.
 *
 * @generated from protobuf message rd.llm.Fragment
 */
export interface Fragment {
    /**
     * @generated from protobuf field: int32 block_index = 1
     */
    blockIndex: number;
    /**
     * @generated from protobuf field: rd.llm.Message.Block.Type block_type = 2
     */
    blockType: Message_Block_Type;
    /**
     * @generated from protobuf field: bytes partial_content = 3
     */
    partialContent: Uint8Array;
    /**
     * @generated from protobuf field: string tool_name = 4
     */
    toolName: string;
    /**
     * @generated from protobuf field: string tool_request_id = 5
     */
    toolRequestId: string;
    /**
     * @generated from protobuf field: repeated string file_ids = 6
     */
    fileIds: string[];
    /**
     * @generated from protobuf field: string container_id = 7
     */
    containerId: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp container_expires_at = 8
     */
    containerExpiresAt?: Timestamp;
    /**
     * @generated from protobuf field: string mcp_server_name = 9
     */
    mcpServerName: string;
    /**
     * @generated from protobuf field: bool is_error = 10
     */
    isError: boolean;
    /**
     * usage carries incremental usage updates from the provider stream. These
     * fragments carry no block content.
     *
     * @generated from protobuf field: rd.llm.Usage usage = 11
     */
    usage?: Usage;
    /**
     * caller_tool_request_id is set when this fragment carries a complete
     * tool_use block that was invoked programmatically from a server-side
     * tool — e.g. a script running in a code_execution sandbox calling one
     * of our custom tools. It references the calling server_tool_use external_id.
     *
     * @generated from protobuf field: string caller_tool_request_id = 12
     */
    callerToolRequestId: string;
    /**
     * stop_reason is the provider's terminal reason for the assistant turn.
     * Populated on the terminal fragment of the stream.
     *
     * @generated from protobuf field: rd.llm.StopReason stop_reason = 13
     */
    stopReason: StopReason;
    /**
     * signature carries the opaque thinking-block signature, delivered on its
     * own delta separate from the thinking text. Empty on non-thinking
     * fragments.
     *
     * @generated from protobuf field: string signature = 14
     */
    signature: string;
}
/**
 * UserAppContext stores information about where the user is in the web app for
 * the LLM to use.
 *
 * @generated from protobuf message rd.llm.UserAppContext
 */
export interface UserAppContext {
    /**
     * @generated from protobuf field: repeated string route_history = 1
     */
    routeHistory: string[];
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID location_id = 2
     */
    locationId?: UUID;
    /**
     * @generated from protobuf field: rd.llm.UserAppContext.Feature feature = 3
     */
    feature?: UserAppContext_Feature;
}
/**
 * Feature stores information about the registered AI integrated feature.
 *
 * @generated from protobuf message rd.llm.UserAppContext.Feature
 */
export interface UserAppContext_Feature {
    /**
     * @generated from protobuf field: rd.llm.UserAppContext.Feature.Type type = 1
     */
    type: UserAppContext_Feature_Type;
    /**
     * @generated from protobuf field: rd.llm.UserAppContext.Feature.CustomerChat customer_chat = 2
     */
    customerChat?: UserAppContext_Feature_CustomerChat;
}
/**
 * @generated from protobuf message rd.llm.UserAppContext.Feature.CustomerChat
 */
export interface UserAppContext_Feature_CustomerChat {
    /**
     * @generated from protobuf field: string composer_value = 1
     */
    composerValue: string;
}
/**
 * @generated from protobuf enum rd.llm.UserAppContext.Feature.Type
 */
export enum UserAppContext_Feature_Type {
    /**
     * @generated from protobuf enum value: TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: TYPE_CUSTOMER_CHAT = 1;
     */
    CUSTOMER_CHAT = 1
}
/**
 * DailySummaryNotificationCopy represents the user-facing copy for the daily summary notification.
 *
 * @generated from protobuf message rd.llm.DailySummaryNotificationCopy
 */
export interface DailySummaryNotificationCopy {
    /**
     * @generated from protobuf field: string subject = 1
     */
    subject: string;
    /**
     * @generated from protobuf field: string content = 2
     */
    content: string;
}
/**
 * RoutineNotificationCopy represents the user-facing copy for a routine run notification.
 *
 * @generated from protobuf message rd.llm.RoutineNotificationCopy
 */
export interface RoutineNotificationCopy {
    /**
     * @generated from protobuf field: string subject = 1
     */
    subject: string;
    /**
     * @generated from protobuf field: string content = 2
     */
    content: string;
}
/**
 * Memory represents a memory item for the LLM to use. The LLM models these as files but we use
 * records as we use a serverless backend.
 *
 * @generated from protobuf message rd.llm.Memory
 */
export interface Memory {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 2
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 3
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp last_used = 4
     */
    lastUsed?: Timestamp;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID company_id = 5
     */
    companyId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID user_id = 6
     */
    userId?: UUID;
    /**
     * @generated from protobuf field: string path = 7
     */
    path: string;
    /**
     * @generated from protobuf field: repeated string content = 8
     */
    content: string[];
    /**
     * @generated from protobuf field: string parent_path = 9
     */
    parentPath: string;
    /**
     * @generated from protobuf field: rd.llm.Memory.Type type = 10
     */
    type: Memory_Type;
}
/**
 * @generated from protobuf enum rd.llm.Memory.Type
 */
export enum Memory_Type {
    /**
     * @generated from protobuf enum value: TYPE_UNDEFINED = 0;
     */
    UNDEFINED = 0,
    /**
     * @generated from protobuf enum value: TYPE_ANTHROPIC_MEMORY = 1;
     */
    ANTHROPIC_MEMORY = 1
}
/**
 * CronScheduleOutput is the structured output schema for LLM-generated cron expressions.
 *
 * @generated from protobuf message rd.llm.CronScheduleOutput
 */
export interface CronScheduleOutput {
    /**
     * @generated from protobuf field: string cron_expression = 1
     */
    cronExpression: string;
}
/**
 * CategoryIconNameOutput is the structured output schema for an LLM-suggested icon name
 * for a product category.
 *
 * @generated from protobuf message rd.llm.CategoryIconNameOutput
 */
export interface CategoryIconNameOutput {
    /**
     * @generated from protobuf field: string icon_name = 1
     */
    iconName: string;
}
/**
 * PriceSuggestionOutput is the structured output schema for an LLM-suggested retail price for a
 * catalog product.
 *
 * @generated from protobuf message rd.llm.PriceSuggestionOutput
 */
export interface PriceSuggestionOutput {
    /**
     * @generated from protobuf field: int32 suggested_price_cents = 1
     */
    suggestedPriceCents: number;
}
/**
 * @generated from protobuf message rd.llm.Routine
 */
export interface Routine {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID company_id = 3
     */
    companyId?: UUID;
    /**
     * @generated from protobuf field: rd.llm.Routine.Type type = 4
     */
    type: Routine_Type;
    /**
     * @generated from protobuf field: string user_prompt = 5
     */
    userPrompt: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp last_run_at = 6
     */
    lastRunAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 7
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 8
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: bool is_active = 9
     */
    isActive: boolean;
    /**
     * @generated from protobuf field: string name = 10
     */
    name: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp scheduled_run_time = 11
     */
    scheduledRunTime?: Timestamp;
    /**
     * @generated from protobuf field: string cron_schedule_prompt = 12
     */
    cronSchedulePrompt: string;
    /**
     * @generated from protobuf field: string cron_schedule = 13
     */
    cronSchedule: string; // cron schedule expression for the routine of the form "* * * * *"
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID staff_ids = 14
     */
    staffIds: UUID[];
}
/**
 * @generated from protobuf enum rd.llm.Routine.Type
 */
export enum Routine_Type {
    /**
     * @generated from protobuf enum value: TYPE_UNDEFINED = 0;
     */
    UNDEFINED = 0,
    /**
     * @generated from protobuf enum value: TYPE_DAILY_SUMMARY = 1;
     */
    DAILY_SUMMARY = 1,
    /**
     * @generated from protobuf enum value: TYPE_ORDER = 2;
     */
    ORDER = 2,
    /**
     * @generated from protobuf enum value: TYPE_REPORT = 3;
     */
    REPORT = 3,
    /**
     * @generated from protobuf enum value: TYPE_GENERAL = 4;
     */
    GENERAL = 4
}
/**
 * @generated from protobuf message rd.llm.UsageTracking
 */
export interface UsageTracking {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID company_id = 2
     */
    companyId?: UUID;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 3
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 4
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp expires_at = 5
     */
    expiresAt?: Timestamp;
    /**
     * @generated from protobuf field: rd.proto.money.Money usage_limit = 6
     */
    usageLimit?: Money;
    /**
     * @generated from protobuf field: rd.proto.money.Money additional_usage_limit = 7
     */
    additionalUsageLimit?: Money;
    /**
     * @generated from protobuf field: rd.llm.Usage cumulative_usage = 8
     */
    cumulativeUsage?: Usage;
}
/**
 * ClientProvider defines different LLM providers.
 *
 * @generated from protobuf enum rd.llm.ClientProvider
 */
export enum ClientProvider {
    /**
     * @generated from protobuf enum value: CLIENT_PROVIDER_DEFAULT = 0;
     */
    DEFAULT = 0,
    /**
     * @generated from protobuf enum value: CLIENT_PROVIDER_ANTHROPIC = 1;
     */
    ANTHROPIC = 1,
    /**
     * @generated from protobuf enum value: CLIENT_PROVIDER_GOOGLE = 2;
     */
    GOOGLE = 2,
    /**
     * @generated from protobuf enum value: CLIENT_PROVIDER_OPENAI = 3;
     */
    OPENAI = 3
}
/**
 * Model defines specific models for each provider.
 *
 * @generated from protobuf enum rd.llm.Model
 */
export enum Model {
    /**
     * @generated from protobuf enum value: MODEL_UNDEFINED = 0;
     */
    UNDEFINED = 0,
    /**
     * @generated from protobuf enum value: MODEL_ANTHROPIC_CLAUDE_SONNET_4_5 = 1;
     */
    ANTHROPIC_CLAUDE_SONNET_4_5 = 1,
    /**
     * @generated from protobuf enum value: MODEL_ANTHROPIC_CLAUDE_HAIKU_4_5 = 2;
     */
    ANTHROPIC_CLAUDE_HAIKU_4_5 = 2,
    /**
     * @generated from protobuf enum value: MODEL_ANTHROPIC_CLAUDE_SONNET_4_6 = 3;
     */
    ANTHROPIC_CLAUDE_SONNET_4_6 = 3
}
/**
 * StopReason is the terminal reason a provider returns for an assistant turn.
 * Names mirror the cross-provider concepts; map provider-specific strings to
 * these values in each client.
 *
 * @generated from protobuf enum rd.llm.StopReason
 */
export enum StopReason {
    /**
     * @generated from protobuf enum value: STOP_REASON_UNDEFINED = 0;
     */
    UNDEFINED = 0,
    /**
     * @generated from protobuf enum value: STOP_REASON_END_TURN = 1;
     */
    END_TURN = 1,
    /**
     * @generated from protobuf enum value: STOP_REASON_TOOL_USE = 2;
     */
    TOOL_USE = 2,
    /**
     * @generated from protobuf enum value: STOP_REASON_MAX_TOKENS = 3;
     */
    MAX_TOKENS = 3,
    /**
     * @generated from protobuf enum value: STOP_REASON_STOP_SEQUENCE = 4;
     */
    STOP_SEQUENCE = 4,
    /**
     * @generated from protobuf enum value: STOP_REASON_PAUSE_TURN = 5;
     */
    PAUSE_TURN = 5,
    /**
     * @generated from protobuf enum value: STOP_REASON_REFUSAL = 6;
     */
    REFUSAL = 6,
    /**
     * @generated from protobuf enum value: STOP_REASON_MODEL_CONTEXT_WINDOW_EXCEEDED = 7;
     */
    MODEL_CONTEXT_WINDOW_EXCEEDED = 7
}
// @generated message type with reflection information, may provide speed optimized methods
class Conversation$Type extends MessageType<Conversation> {
    constructor() {
        super("rd.llm.Conversation", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "company_id", kind: "message", T: () => UUID },
            { no: 3, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 4, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 5, name: "user_id", kind: "message", T: () => UUID },
            { no: 6, name: "messages", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Message },
            { no: 7, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "external_conversation", kind: "message", T: () => Conversation_ExternalConversation },
            { no: 9, name: "type", kind: "enum", T: () => ["rd.llm.Conversation.Type", Conversation_Type, "TYPE_"] },
            { no: 10, name: "routine_id", kind: "message", T: () => UUID },
            { no: 11, name: "source_conversation_id", kind: "message", T: () => UUID },
            { no: 12, name: "total_usage", kind: "message", T: () => Usage }
        ]);
    }
    create(value?: PartialMessage<Conversation>): Conversation {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.messages = [];
        message.name = "";
        message.type = 0;
        if (value !== undefined)
            reflectionMergePartial<Conversation>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Conversation): Conversation {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* rd.proto.uuid.UUID company_id */ 2:
                    message.companyId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.companyId);
                    break;
                case /* google.protobuf.Timestamp created_at */ 3:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 4:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* rd.proto.uuid.UUID user_id */ 5:
                    message.userId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.userId);
                    break;
                case /* repeated rd.llm.Message messages */ 6:
                    message.messages.push(Message.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string name */ 7:
                    message.name = reader.string();
                    break;
                case /* rd.llm.Conversation.ExternalConversation external_conversation */ 8:
                    message.externalConversation = Conversation_ExternalConversation.internalBinaryRead(reader, reader.uint32(), options, message.externalConversation);
                    break;
                case /* rd.llm.Conversation.Type type */ 9:
                    message.type = reader.int32();
                    break;
                case /* rd.proto.uuid.UUID routine_id */ 10:
                    message.routineId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.routineId);
                    break;
                case /* rd.proto.uuid.UUID source_conversation_id */ 11:
                    message.sourceConversationId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.sourceConversationId);
                    break;
                case /* rd.llm.Usage total_usage */ 12:
                    message.totalUsage = Usage.internalBinaryRead(reader, reader.uint32(), options, message.totalUsage);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Conversation, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID company_id = 2; */
        if (message.companyId)
            UUID.internalBinaryWrite(message.companyId, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp created_at = 3; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 4; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID user_id = 5; */
        if (message.userId)
            UUID.internalBinaryWrite(message.userId, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.llm.Message messages = 6; */
        for (let i = 0; i < message.messages.length; i++)
            Message.internalBinaryWrite(message.messages[i], writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* string name = 7; */
        if (message.name !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.name);
        /* rd.llm.Conversation.ExternalConversation external_conversation = 8; */
        if (message.externalConversation)
            Conversation_ExternalConversation.internalBinaryWrite(message.externalConversation, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* rd.llm.Conversation.Type type = 9; */
        if (message.type !== 0)
            writer.tag(9, WireType.Varint).int32(message.type);
        /* rd.proto.uuid.UUID routine_id = 10; */
        if (message.routineId)
            UUID.internalBinaryWrite(message.routineId, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID source_conversation_id = 11; */
        if (message.sourceConversationId)
            UUID.internalBinaryWrite(message.sourceConversationId, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* rd.llm.Usage total_usage = 12; */
        if (message.totalUsage)
            Usage.internalBinaryWrite(message.totalUsage, writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.llm.Conversation
 */
export const Conversation = new Conversation$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Conversation_ExternalConversation$Type extends MessageType<Conversation_ExternalConversation> {
    constructor() {
        super("rd.llm.Conversation.ExternalConversation", [
            { no: 1, name: "external_conversation_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "status", kind: "enum", T: () => ["rd.llm.Conversation.ExternalConversation.Status", Conversation_ExternalConversation_Status, "STATUS_"] },
            { no: 3, name: "sse_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<Conversation_ExternalConversation>): Conversation_ExternalConversation {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.externalConversationId = "";
        message.status = 0;
        message.sseUrl = "";
        if (value !== undefined)
            reflectionMergePartial<Conversation_ExternalConversation>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Conversation_ExternalConversation): Conversation_ExternalConversation {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string external_conversation_id */ 1:
                    message.externalConversationId = reader.string();
                    break;
                case /* rd.llm.Conversation.ExternalConversation.Status status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string sse_url */ 3:
                    message.sseUrl = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Conversation_ExternalConversation, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string external_conversation_id = 1; */
        if (message.externalConversationId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.externalConversationId);
        /* rd.llm.Conversation.ExternalConversation.Status status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string sse_url = 3; */
        if (message.sseUrl !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.sseUrl);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.llm.Conversation.ExternalConversation
 */
export const Conversation_ExternalConversation = new Conversation_ExternalConversation$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Usage$Type extends MessageType<Usage> {
    constructor() {
        super("rd.llm.Usage", [
            { no: 1, name: "input_tokens", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "output_tokens", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 3, name: "cache_creation_input_tokens", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 4, name: "cache_read_input_tokens", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 5, name: "cache_creation", kind: "message", T: () => Usage_CacheCreation }
        ]);
    }
    create(value?: PartialMessage<Usage>): Usage {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.inputTokens = 0n;
        message.outputTokens = 0n;
        message.cacheCreationInputTokens = 0n;
        message.cacheReadInputTokens = 0n;
        if (value !== undefined)
            reflectionMergePartial<Usage>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Usage): Usage {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 input_tokens */ 1:
                    message.inputTokens = reader.int64().toBigInt();
                    break;
                case /* int64 output_tokens */ 2:
                    message.outputTokens = reader.int64().toBigInt();
                    break;
                case /* int64 cache_creation_input_tokens */ 3:
                    message.cacheCreationInputTokens = reader.int64().toBigInt();
                    break;
                case /* int64 cache_read_input_tokens */ 4:
                    message.cacheReadInputTokens = reader.int64().toBigInt();
                    break;
                case /* rd.llm.Usage.CacheCreation cache_creation */ 5:
                    message.cacheCreation = Usage_CacheCreation.internalBinaryRead(reader, reader.uint32(), options, message.cacheCreation);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Usage, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 input_tokens = 1; */
        if (message.inputTokens !== 0n)
            writer.tag(1, WireType.Varint).int64(message.inputTokens);
        /* int64 output_tokens = 2; */
        if (message.outputTokens !== 0n)
            writer.tag(2, WireType.Varint).int64(message.outputTokens);
        /* int64 cache_creation_input_tokens = 3; */
        if (message.cacheCreationInputTokens !== 0n)
            writer.tag(3, WireType.Varint).int64(message.cacheCreationInputTokens);
        /* int64 cache_read_input_tokens = 4; */
        if (message.cacheReadInputTokens !== 0n)
            writer.tag(4, WireType.Varint).int64(message.cacheReadInputTokens);
        /* rd.llm.Usage.CacheCreation cache_creation = 5; */
        if (message.cacheCreation)
            Usage_CacheCreation.internalBinaryWrite(message.cacheCreation, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.llm.Usage
 */
export const Usage = new Usage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Usage_CacheCreation$Type extends MessageType<Usage_CacheCreation> {
    constructor() {
        super("rd.llm.Usage.CacheCreation", [
            { no: 1, name: "ephemeral_5m_input_tokens", kind: "scalar", jsonName: "ephemeral5mInputTokens", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "ephemeral_1h_input_tokens", kind: "scalar", jsonName: "ephemeral1hInputTokens", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value?: PartialMessage<Usage_CacheCreation>): Usage_CacheCreation {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.ephemeral5MInputTokens = 0n;
        message.ephemeral1HInputTokens = 0n;
        if (value !== undefined)
            reflectionMergePartial<Usage_CacheCreation>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Usage_CacheCreation): Usage_CacheCreation {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 ephemeral_5m_input_tokens */ 1:
                    message.ephemeral5MInputTokens = reader.int64().toBigInt();
                    break;
                case /* int64 ephemeral_1h_input_tokens */ 2:
                    message.ephemeral1HInputTokens = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Usage_CacheCreation, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 ephemeral_5m_input_tokens = 1; */
        if (message.ephemeral5MInputTokens !== 0n)
            writer.tag(1, WireType.Varint).int64(message.ephemeral5MInputTokens);
        /* int64 ephemeral_1h_input_tokens = 2; */
        if (message.ephemeral1HInputTokens !== 0n)
            writer.tag(2, WireType.Varint).int64(message.ephemeral1HInputTokens);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.llm.Usage.CacheCreation
 */
export const Usage_CacheCreation = new Usage_CacheCreation$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Message$Type extends MessageType<Message> {
    constructor() {
        super("rd.llm.Message", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "role", kind: "enum", T: () => ["rd.llm.Message.Role", Message_Role, "ROLE_"] },
            { no: 3, name: "blocks", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Message_Block },
            { no: 4, name: "status", kind: "enum", T: () => ["rd.llm.Message.Status", Message_Status, "STATUS_"] },
            { no: 5, name: "app_context", kind: "message", T: () => UserAppContext },
            { no: 6, name: "container", kind: "message", T: () => Message_Container },
            { no: 7, name: "usage", kind: "message", T: () => Usage },
            { no: 8, name: "feedback", kind: "message", T: () => Message_Feedback },
            { no: 9, name: "created_at", kind: "message", T: () => Timestamp }
        ]);
    }
    create(value?: PartialMessage<Message>): Message {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.role = 0;
        message.blocks = [];
        message.status = 0;
        if (value !== undefined)
            reflectionMergePartial<Message>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Message): Message {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* rd.llm.Message.Role role */ 2:
                    message.role = reader.int32();
                    break;
                case /* repeated rd.llm.Message.Block blocks */ 3:
                    message.blocks.push(Message_Block.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* rd.llm.Message.Status status */ 4:
                    message.status = reader.int32();
                    break;
                case /* rd.llm.UserAppContext app_context */ 5:
                    message.appContext = UserAppContext.internalBinaryRead(reader, reader.uint32(), options, message.appContext);
                    break;
                case /* rd.llm.Message.Container container */ 6:
                    message.container = Message_Container.internalBinaryRead(reader, reader.uint32(), options, message.container);
                    break;
                case /* rd.llm.Usage usage */ 7:
                    message.usage = Usage.internalBinaryRead(reader, reader.uint32(), options, message.usage);
                    break;
                case /* rd.llm.Message.Feedback feedback */ 8:
                    message.feedback = Message_Feedback.internalBinaryRead(reader, reader.uint32(), options, message.feedback);
                    break;
                case /* google.protobuf.Timestamp created_at */ 9:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Message, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.llm.Message.Role role = 2; */
        if (message.role !== 0)
            writer.tag(2, WireType.Varint).int32(message.role);
        /* repeated rd.llm.Message.Block blocks = 3; */
        for (let i = 0; i < message.blocks.length; i++)
            Message_Block.internalBinaryWrite(message.blocks[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.llm.Message.Status status = 4; */
        if (message.status !== 0)
            writer.tag(4, WireType.Varint).int32(message.status);
        /* rd.llm.UserAppContext app_context = 5; */
        if (message.appContext)
            UserAppContext.internalBinaryWrite(message.appContext, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* rd.llm.Message.Container container = 6; */
        if (message.container)
            Message_Container.internalBinaryWrite(message.container, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* rd.llm.Usage usage = 7; */
        if (message.usage)
            Usage.internalBinaryWrite(message.usage, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* rd.llm.Message.Feedback feedback = 8; */
        if (message.feedback)
            Message_Feedback.internalBinaryWrite(message.feedback, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp created_at = 9; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.llm.Message
 */
export const Message = new Message$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Message_Block$Type extends MessageType<Message_Block> {
    constructor() {
        super("rd.llm.Message.Block", [
            { no: 1, name: "type", kind: "enum", T: () => ["rd.llm.Message.Block.Type", Message_Block_Type, "TYPE_"] },
            { no: 2, name: "content", kind: "scalar", T: 12 /*ScalarType.BYTES*/ },
            { no: 3, name: "content_string", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "tool_request", kind: "message", T: () => Message_Block_ToolRequest },
            { no: 5, name: "tool_response", kind: "message", T: () => Message_Block_ToolResponse },
            { no: 6, name: "audio", kind: "message", T: () => Message_Block_Audio },
            { no: 7, name: "image", kind: "message", T: () => Message_Block_Image },
            { no: 8, name: "document", kind: "message", T: () => Message_Block_Document },
            { no: 9, name: "server_tool_request", kind: "message", T: () => Message_Block_ServerToolRequest },
            { no: 10, name: "server_tool_response", kind: "message", T: () => Message_Block_ServerToolResponse },
            { no: 11, name: "draft", kind: "message", T: () => Message_Block_Draft },
            { no: 12, name: "mcp_tool_request", kind: "message", T: () => Message_Block_MCPToolRequest },
            { no: 13, name: "mcp_tool_response", kind: "message", T: () => Message_Block_MCPToolResponse },
            { no: 14, name: "thinking", kind: "message", T: () => Message_Block_Thinking }
        ]);
    }
    create(value?: PartialMessage<Message_Block>): Message_Block {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.type = 0;
        message.content = new Uint8Array(0);
        message.contentString = "";
        if (value !== undefined)
            reflectionMergePartial<Message_Block>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Message_Block): Message_Block {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.llm.Message.Block.Type type */ 1:
                    message.type = reader.int32();
                    break;
                case /* bytes content */ 2:
                    message.content = reader.bytes();
                    break;
                case /* string content_string */ 3:
                    message.contentString = reader.string();
                    break;
                case /* rd.llm.Message.Block.ToolRequest tool_request */ 4:
                    message.toolRequest = Message_Block_ToolRequest.internalBinaryRead(reader, reader.uint32(), options, message.toolRequest);
                    break;
                case /* rd.llm.Message.Block.ToolResponse tool_response */ 5:
                    message.toolResponse = Message_Block_ToolResponse.internalBinaryRead(reader, reader.uint32(), options, message.toolResponse);
                    break;
                case /* rd.llm.Message.Block.Audio audio */ 6:
                    message.audio = Message_Block_Audio.internalBinaryRead(reader, reader.uint32(), options, message.audio);
                    break;
                case /* rd.llm.Message.Block.Image image */ 7:
                    message.image = Message_Block_Image.internalBinaryRead(reader, reader.uint32(), options, message.image);
                    break;
                case /* rd.llm.Message.Block.Document document */ 8:
                    message.document = Message_Block_Document.internalBinaryRead(reader, reader.uint32(), options, message.document);
                    break;
                case /* rd.llm.Message.Block.ServerToolRequest server_tool_request */ 9:
                    message.serverToolRequest = Message_Block_ServerToolRequest.internalBinaryRead(reader, reader.uint32(), options, message.serverToolRequest);
                    break;
                case /* rd.llm.Message.Block.ServerToolResponse server_tool_response */ 10:
                    message.serverToolResponse = Message_Block_ServerToolResponse.internalBinaryRead(reader, reader.uint32(), options, message.serverToolResponse);
                    break;
                case /* rd.llm.Message.Block.Draft draft */ 11:
                    message.draft = Message_Block_Draft.internalBinaryRead(reader, reader.uint32(), options, message.draft);
                    break;
                case /* rd.llm.Message.Block.MCPToolRequest mcp_tool_request */ 12:
                    message.mcpToolRequest = Message_Block_MCPToolRequest.internalBinaryRead(reader, reader.uint32(), options, message.mcpToolRequest);
                    break;
                case /* rd.llm.Message.Block.MCPToolResponse mcp_tool_response */ 13:
                    message.mcpToolResponse = Message_Block_MCPToolResponse.internalBinaryRead(reader, reader.uint32(), options, message.mcpToolResponse);
                    break;
                case /* rd.llm.Message.Block.Thinking thinking */ 14:
                    message.thinking = Message_Block_Thinking.internalBinaryRead(reader, reader.uint32(), options, message.thinking);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Message_Block, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.llm.Message.Block.Type type = 1; */
        if (message.type !== 0)
            writer.tag(1, WireType.Varint).int32(message.type);
        /* bytes content = 2; */
        if (message.content.length)
            writer.tag(2, WireType.LengthDelimited).bytes(message.content);
        /* string content_string = 3; */
        if (message.contentString !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.contentString);
        /* rd.llm.Message.Block.ToolRequest tool_request = 4; */
        if (message.toolRequest)
            Message_Block_ToolRequest.internalBinaryWrite(message.toolRequest, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* rd.llm.Message.Block.ToolResponse tool_response = 5; */
        if (message.toolResponse)
            Message_Block_ToolResponse.internalBinaryWrite(message.toolResponse, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* rd.llm.Message.Block.Audio audio = 6; */
        if (message.audio)
            Message_Block_Audio.internalBinaryWrite(message.audio, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* rd.llm.Message.Block.Image image = 7; */
        if (message.image)
            Message_Block_Image.internalBinaryWrite(message.image, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* rd.llm.Message.Block.Document document = 8; */
        if (message.document)
            Message_Block_Document.internalBinaryWrite(message.document, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* rd.llm.Message.Block.ServerToolRequest server_tool_request = 9; */
        if (message.serverToolRequest)
            Message_Block_ServerToolRequest.internalBinaryWrite(message.serverToolRequest, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* rd.llm.Message.Block.ServerToolResponse server_tool_response = 10; */
        if (message.serverToolResponse)
            Message_Block_ServerToolResponse.internalBinaryWrite(message.serverToolResponse, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* rd.llm.Message.Block.Draft draft = 11; */
        if (message.draft)
            Message_Block_Draft.internalBinaryWrite(message.draft, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* rd.llm.Message.Block.MCPToolRequest mcp_tool_request = 12; */
        if (message.mcpToolRequest)
            Message_Block_MCPToolRequest.internalBinaryWrite(message.mcpToolRequest, writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* rd.llm.Message.Block.MCPToolResponse mcp_tool_response = 13; */
        if (message.mcpToolResponse)
            Message_Block_MCPToolResponse.internalBinaryWrite(message.mcpToolResponse, writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        /* rd.llm.Message.Block.Thinking thinking = 14; */
        if (message.thinking)
            Message_Block_Thinking.internalBinaryWrite(message.thinking, writer.tag(14, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.llm.Message.Block
 */
export const Message_Block = new Message_Block$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Message_Block_ToolRequest$Type extends MessageType<Message_Block_ToolRequest> {
    constructor() {
        super("rd.llm.Message.Block.ToolRequest", [
            { no: 1, name: "tool_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "input_json", kind: "scalar", T: 12 /*ScalarType.BYTES*/ },
            { no: 3, name: "external_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "external_caller_tool_request_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<Message_Block_ToolRequest>): Message_Block_ToolRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.toolName = "";
        message.inputJson = new Uint8Array(0);
        message.externalId = "";
        message.externalCallerToolRequestId = "";
        if (value !== undefined)
            reflectionMergePartial<Message_Block_ToolRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Message_Block_ToolRequest): Message_Block_ToolRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string tool_name */ 1:
                    message.toolName = reader.string();
                    break;
                case /* bytes input_json */ 2:
                    message.inputJson = reader.bytes();
                    break;
                case /* string external_id */ 3:
                    message.externalId = reader.string();
                    break;
                case /* string external_caller_tool_request_id */ 4:
                    message.externalCallerToolRequestId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Message_Block_ToolRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string tool_name = 1; */
        if (message.toolName !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.toolName);
        /* bytes input_json = 2; */
        if (message.inputJson.length)
            writer.tag(2, WireType.LengthDelimited).bytes(message.inputJson);
        /* string external_id = 3; */
        if (message.externalId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.externalId);
        /* string external_caller_tool_request_id = 4; */
        if (message.externalCallerToolRequestId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.externalCallerToolRequestId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.llm.Message.Block.ToolRequest
 */
export const Message_Block_ToolRequest = new Message_Block_ToolRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Message_Block_ToolResponse$Type extends MessageType<Message_Block_ToolResponse> {
    constructor() {
        super("rd.llm.Message.Block.ToolResponse", [
            { no: 1, name: "tool_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "output", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "error", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "external_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<Message_Block_ToolResponse>): Message_Block_ToolResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.toolName = "";
        message.output = "";
        message.error = "";
        message.externalId = "";
        if (value !== undefined)
            reflectionMergePartial<Message_Block_ToolResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Message_Block_ToolResponse): Message_Block_ToolResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string tool_name */ 1:
                    message.toolName = reader.string();
                    break;
                case /* string output */ 2:
                    message.output = reader.string();
                    break;
                case /* string error */ 3:
                    message.error = reader.string();
                    break;
                case /* string external_id */ 4:
                    message.externalId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Message_Block_ToolResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string tool_name = 1; */
        if (message.toolName !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.toolName);
        /* string output = 2; */
        if (message.output !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.output);
        /* string error = 3; */
        if (message.error !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.error);
        /* string external_id = 4; */
        if (message.externalId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.externalId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.llm.Message.Block.ToolResponse
 */
export const Message_Block_ToolResponse = new Message_Block_ToolResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Message_Block_Audio$Type extends MessageType<Message_Block_Audio> {
    constructor() {
        super("rd.llm.Message.Block.Audio", [
            { no: 1, name: "mime_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "data", kind: "scalar", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
    create(value?: PartialMessage<Message_Block_Audio>): Message_Block_Audio {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.mimeType = "";
        message.data = new Uint8Array(0);
        if (value !== undefined)
            reflectionMergePartial<Message_Block_Audio>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Message_Block_Audio): Message_Block_Audio {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string mime_type */ 1:
                    message.mimeType = reader.string();
                    break;
                case /* bytes data */ 2:
                    message.data = reader.bytes();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Message_Block_Audio, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string mime_type = 1; */
        if (message.mimeType !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.mimeType);
        /* bytes data = 2; */
        if (message.data.length)
            writer.tag(2, WireType.LengthDelimited).bytes(message.data);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.llm.Message.Block.Audio
 */
export const Message_Block_Audio = new Message_Block_Audio$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Message_Block_Image$Type extends MessageType<Message_Block_Image> {
    constructor() {
        super("rd.llm.Message.Block.Image", [
            { no: 1, name: "attachment_id", kind: "message", T: () => UUID },
            { no: 2, name: "external_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "mime_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<Message_Block_Image>): Message_Block_Image {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.externalId = "";
        message.name = "";
        message.mimeType = "";
        if (value !== undefined)
            reflectionMergePartial<Message_Block_Image>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Message_Block_Image): Message_Block_Image {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID attachment_id */ 1:
                    message.attachmentId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.attachmentId);
                    break;
                case /* string external_id */ 2:
                    message.externalId = reader.string();
                    break;
                case /* string name */ 3:
                    message.name = reader.string();
                    break;
                case /* string mime_type */ 4:
                    message.mimeType = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Message_Block_Image, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID attachment_id = 1; */
        if (message.attachmentId)
            UUID.internalBinaryWrite(message.attachmentId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string external_id = 2; */
        if (message.externalId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.externalId);
        /* string name = 3; */
        if (message.name !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.name);
        /* string mime_type = 4; */
        if (message.mimeType !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.mimeType);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.llm.Message.Block.Image
 */
export const Message_Block_Image = new Message_Block_Image$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Message_Block_Document$Type extends MessageType<Message_Block_Document> {
    constructor() {
        super("rd.llm.Message.Block.Document", [
            { no: 1, name: "attachment_id", kind: "message", T: () => UUID },
            { no: 2, name: "external_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "mime_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<Message_Block_Document>): Message_Block_Document {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.externalId = "";
        message.name = "";
        message.mimeType = "";
        if (value !== undefined)
            reflectionMergePartial<Message_Block_Document>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Message_Block_Document): Message_Block_Document {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID attachment_id */ 1:
                    message.attachmentId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.attachmentId);
                    break;
                case /* string external_id */ 2:
                    message.externalId = reader.string();
                    break;
                case /* string name */ 3:
                    message.name = reader.string();
                    break;
                case /* string mime_type */ 4:
                    message.mimeType = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Message_Block_Document, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID attachment_id = 1; */
        if (message.attachmentId)
            UUID.internalBinaryWrite(message.attachmentId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string external_id = 2; */
        if (message.externalId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.externalId);
        /* string name = 3; */
        if (message.name !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.name);
        /* string mime_type = 4; */
        if (message.mimeType !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.mimeType);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.llm.Message.Block.Document
 */
export const Message_Block_Document = new Message_Block_Document$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Message_Block_ServerToolRequest$Type extends MessageType<Message_Block_ServerToolRequest> {
    constructor() {
        super("rd.llm.Message.Block.ServerToolRequest", [
            { no: 1, name: "tool_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "input_json", kind: "scalar", T: 12 /*ScalarType.BYTES*/ },
            { no: 3, name: "external_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<Message_Block_ServerToolRequest>): Message_Block_ServerToolRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.toolName = "";
        message.inputJson = new Uint8Array(0);
        message.externalId = "";
        if (value !== undefined)
            reflectionMergePartial<Message_Block_ServerToolRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Message_Block_ServerToolRequest): Message_Block_ServerToolRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string tool_name */ 1:
                    message.toolName = reader.string();
                    break;
                case /* bytes input_json */ 2:
                    message.inputJson = reader.bytes();
                    break;
                case /* string external_id */ 3:
                    message.externalId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Message_Block_ServerToolRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string tool_name = 1; */
        if (message.toolName !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.toolName);
        /* bytes input_json = 2; */
        if (message.inputJson.length)
            writer.tag(2, WireType.LengthDelimited).bytes(message.inputJson);
        /* string external_id = 3; */
        if (message.externalId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.externalId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.llm.Message.Block.ServerToolRequest
 */
export const Message_Block_ServerToolRequest = new Message_Block_ServerToolRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Message_Block_ServerToolResponse$Type extends MessageType<Message_Block_ServerToolResponse> {
    constructor() {
        super("rd.llm.Message.Block.ServerToolResponse", [
            { no: 1, name: "tool_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "external_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "files", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Message_Block_ServerToolResponse_File }
        ]);
    }
    create(value?: PartialMessage<Message_Block_ServerToolResponse>): Message_Block_ServerToolResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.toolName = "";
        message.externalId = "";
        message.files = [];
        if (value !== undefined)
            reflectionMergePartial<Message_Block_ServerToolResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Message_Block_ServerToolResponse): Message_Block_ServerToolResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string tool_name */ 1:
                    message.toolName = reader.string();
                    break;
                case /* string external_id */ 2:
                    message.externalId = reader.string();
                    break;
                case /* repeated rd.llm.Message.Block.ServerToolResponse.File files */ 3:
                    message.files.push(Message_Block_ServerToolResponse_File.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Message_Block_ServerToolResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string tool_name = 1; */
        if (message.toolName !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.toolName);
        /* string external_id = 2; */
        if (message.externalId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.externalId);
        /* repeated rd.llm.Message.Block.ServerToolResponse.File files = 3; */
        for (let i = 0; i < message.files.length; i++)
            Message_Block_ServerToolResponse_File.internalBinaryWrite(message.files[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.llm.Message.Block.ServerToolResponse
 */
export const Message_Block_ServerToolResponse = new Message_Block_ServerToolResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Message_Block_ServerToolResponse_File$Type extends MessageType<Message_Block_ServerToolResponse_File> {
    constructor() {
        super("rd.llm.Message.Block.ServerToolResponse.File", [
            { no: 1, name: "attachment_id", kind: "message", T: () => UUID },
            { no: 2, name: "external_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<Message_Block_ServerToolResponse_File>): Message_Block_ServerToolResponse_File {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.externalId = "";
        if (value !== undefined)
            reflectionMergePartial<Message_Block_ServerToolResponse_File>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Message_Block_ServerToolResponse_File): Message_Block_ServerToolResponse_File {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID attachment_id */ 1:
                    message.attachmentId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.attachmentId);
                    break;
                case /* string external_id */ 2:
                    message.externalId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Message_Block_ServerToolResponse_File, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID attachment_id = 1; */
        if (message.attachmentId)
            UUID.internalBinaryWrite(message.attachmentId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string external_id = 2; */
        if (message.externalId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.externalId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.llm.Message.Block.ServerToolResponse.File
 */
export const Message_Block_ServerToolResponse_File = new Message_Block_ServerToolResponse_File$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Message_Block_Draft$Type extends MessageType<Message_Block_Draft> {
    constructor() {
        super("rd.llm.Message.Block.Draft", [
            { no: 1, name: "review_status", kind: "enum", T: () => ["rd.llm.Message.Block.Draft.ReviewStatus", Message_Block_Draft_ReviewStatus, "REVIEW_STATUS_"] }
        ]);
    }
    create(value?: PartialMessage<Message_Block_Draft>): Message_Block_Draft {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.reviewStatus = 0;
        if (value !== undefined)
            reflectionMergePartial<Message_Block_Draft>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Message_Block_Draft): Message_Block_Draft {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.llm.Message.Block.Draft.ReviewStatus review_status */ 1:
                    message.reviewStatus = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Message_Block_Draft, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.llm.Message.Block.Draft.ReviewStatus review_status = 1; */
        if (message.reviewStatus !== 0)
            writer.tag(1, WireType.Varint).int32(message.reviewStatus);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.llm.Message.Block.Draft
 */
export const Message_Block_Draft = new Message_Block_Draft$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Message_Block_MCPToolRequest$Type extends MessageType<Message_Block_MCPToolRequest> {
    constructor() {
        super("rd.llm.Message.Block.MCPToolRequest", [
            { no: 1, name: "tool_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "input_json", kind: "scalar", T: 12 /*ScalarType.BYTES*/ },
            { no: 3, name: "external_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "mcp_server_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<Message_Block_MCPToolRequest>): Message_Block_MCPToolRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.toolName = "";
        message.inputJson = new Uint8Array(0);
        message.externalId = "";
        message.mcpServerName = "";
        if (value !== undefined)
            reflectionMergePartial<Message_Block_MCPToolRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Message_Block_MCPToolRequest): Message_Block_MCPToolRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string tool_name */ 1:
                    message.toolName = reader.string();
                    break;
                case /* bytes input_json */ 2:
                    message.inputJson = reader.bytes();
                    break;
                case /* string external_id */ 3:
                    message.externalId = reader.string();
                    break;
                case /* string mcp_server_name */ 4:
                    message.mcpServerName = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Message_Block_MCPToolRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string tool_name = 1; */
        if (message.toolName !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.toolName);
        /* bytes input_json = 2; */
        if (message.inputJson.length)
            writer.tag(2, WireType.LengthDelimited).bytes(message.inputJson);
        /* string external_id = 3; */
        if (message.externalId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.externalId);
        /* string mcp_server_name = 4; */
        if (message.mcpServerName !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.mcpServerName);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.llm.Message.Block.MCPToolRequest
 */
export const Message_Block_MCPToolRequest = new Message_Block_MCPToolRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Message_Block_MCPToolResponse$Type extends MessageType<Message_Block_MCPToolResponse> {
    constructor() {
        super("rd.llm.Message.Block.MCPToolResponse", [
            { no: 1, name: "tool_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "external_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "error", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<Message_Block_MCPToolResponse>): Message_Block_MCPToolResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.toolName = "";
        message.externalId = "";
        message.error = "";
        if (value !== undefined)
            reflectionMergePartial<Message_Block_MCPToolResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Message_Block_MCPToolResponse): Message_Block_MCPToolResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string tool_name */ 1:
                    message.toolName = reader.string();
                    break;
                case /* string external_id */ 2:
                    message.externalId = reader.string();
                    break;
                case /* string error */ 3:
                    message.error = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Message_Block_MCPToolResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string tool_name = 1; */
        if (message.toolName !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.toolName);
        /* string external_id = 2; */
        if (message.externalId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.externalId);
        /* string error = 3; */
        if (message.error !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.error);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.llm.Message.Block.MCPToolResponse
 */
export const Message_Block_MCPToolResponse = new Message_Block_MCPToolResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Message_Block_Thinking$Type extends MessageType<Message_Block_Thinking> {
    constructor() {
        super("rd.llm.Message.Block.Thinking", [
            { no: 1, name: "signature", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<Message_Block_Thinking>): Message_Block_Thinking {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.signature = "";
        if (value !== undefined)
            reflectionMergePartial<Message_Block_Thinking>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Message_Block_Thinking): Message_Block_Thinking {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string signature */ 1:
                    message.signature = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Message_Block_Thinking, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string signature = 1; */
        if (message.signature !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.signature);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.llm.Message.Block.Thinking
 */
export const Message_Block_Thinking = new Message_Block_Thinking$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Message_Container$Type extends MessageType<Message_Container> {
    constructor() {
        super("rd.llm.Message.Container", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "expires_at", kind: "message", T: () => Timestamp }
        ]);
    }
    create(value?: PartialMessage<Message_Container>): Message_Container {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<Message_Container>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Message_Container): Message_Container {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* google.protobuf.Timestamp expires_at */ 2:
                    message.expiresAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.expiresAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Message_Container, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* google.protobuf.Timestamp expires_at = 2; */
        if (message.expiresAt)
            Timestamp.internalBinaryWrite(message.expiresAt, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.llm.Message.Container
 */
export const Message_Container = new Message_Container$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Message_Feedback$Type extends MessageType<Message_Feedback> {
    constructor() {
        super("rd.llm.Message.Feedback", [
            { no: 1, name: "sentiment", kind: "enum", T: () => ["rd.llm.Message.Feedback.Sentiment", Message_Feedback_Sentiment, "SENTIMENT_"] },
            { no: 2, name: "comment", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "reason", kind: "enum", T: () => ["rd.llm.Message.Feedback.Reason", Message_Feedback_Reason, "REASON_"] }
        ]);
    }
    create(value?: PartialMessage<Message_Feedback>): Message_Feedback {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.sentiment = 0;
        message.comment = "";
        message.reason = 0;
        if (value !== undefined)
            reflectionMergePartial<Message_Feedback>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Message_Feedback): Message_Feedback {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.llm.Message.Feedback.Sentiment sentiment */ 1:
                    message.sentiment = reader.int32();
                    break;
                case /* string comment */ 2:
                    message.comment = reader.string();
                    break;
                case /* rd.llm.Message.Feedback.Reason reason */ 3:
                    message.reason = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Message_Feedback, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.llm.Message.Feedback.Sentiment sentiment = 1; */
        if (message.sentiment !== 0)
            writer.tag(1, WireType.Varint).int32(message.sentiment);
        /* string comment = 2; */
        if (message.comment !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.comment);
        /* rd.llm.Message.Feedback.Reason reason = 3; */
        if (message.reason !== 0)
            writer.tag(3, WireType.Varint).int32(message.reason);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.llm.Message.Feedback
 */
export const Message_Feedback = new Message_Feedback$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Fragment$Type extends MessageType<Fragment> {
    constructor() {
        super("rd.llm.Fragment", [
            { no: 1, name: "block_index", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "block_type", kind: "enum", T: () => ["rd.llm.Message.Block.Type", Message_Block_Type, "TYPE_"] },
            { no: 3, name: "partial_content", kind: "scalar", T: 12 /*ScalarType.BYTES*/ },
            { no: 4, name: "tool_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "tool_request_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "file_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "container_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "container_expires_at", kind: "message", T: () => Timestamp },
            { no: 9, name: "mcp_server_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "is_error", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 11, name: "usage", kind: "message", T: () => Usage },
            { no: 12, name: "caller_tool_request_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 13, name: "stop_reason", kind: "enum", T: () => ["rd.llm.StopReason", StopReason, "STOP_REASON_"] },
            { no: 14, name: "signature", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<Fragment>): Fragment {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.blockIndex = 0;
        message.blockType = 0;
        message.partialContent = new Uint8Array(0);
        message.toolName = "";
        message.toolRequestId = "";
        message.fileIds = [];
        message.containerId = "";
        message.mcpServerName = "";
        message.isError = false;
        message.callerToolRequestId = "";
        message.stopReason = 0;
        message.signature = "";
        if (value !== undefined)
            reflectionMergePartial<Fragment>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Fragment): Fragment {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 block_index */ 1:
                    message.blockIndex = reader.int32();
                    break;
                case /* rd.llm.Message.Block.Type block_type */ 2:
                    message.blockType = reader.int32();
                    break;
                case /* bytes partial_content */ 3:
                    message.partialContent = reader.bytes();
                    break;
                case /* string tool_name */ 4:
                    message.toolName = reader.string();
                    break;
                case /* string tool_request_id */ 5:
                    message.toolRequestId = reader.string();
                    break;
                case /* repeated string file_ids */ 6:
                    message.fileIds.push(reader.string());
                    break;
                case /* string container_id */ 7:
                    message.containerId = reader.string();
                    break;
                case /* google.protobuf.Timestamp container_expires_at */ 8:
                    message.containerExpiresAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.containerExpiresAt);
                    break;
                case /* string mcp_server_name */ 9:
                    message.mcpServerName = reader.string();
                    break;
                case /* bool is_error */ 10:
                    message.isError = reader.bool();
                    break;
                case /* rd.llm.Usage usage */ 11:
                    message.usage = Usage.internalBinaryRead(reader, reader.uint32(), options, message.usage);
                    break;
                case /* string caller_tool_request_id */ 12:
                    message.callerToolRequestId = reader.string();
                    break;
                case /* rd.llm.StopReason stop_reason */ 13:
                    message.stopReason = reader.int32();
                    break;
                case /* string signature */ 14:
                    message.signature = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Fragment, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 block_index = 1; */
        if (message.blockIndex !== 0)
            writer.tag(1, WireType.Varint).int32(message.blockIndex);
        /* rd.llm.Message.Block.Type block_type = 2; */
        if (message.blockType !== 0)
            writer.tag(2, WireType.Varint).int32(message.blockType);
        /* bytes partial_content = 3; */
        if (message.partialContent.length)
            writer.tag(3, WireType.LengthDelimited).bytes(message.partialContent);
        /* string tool_name = 4; */
        if (message.toolName !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.toolName);
        /* string tool_request_id = 5; */
        if (message.toolRequestId !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.toolRequestId);
        /* repeated string file_ids = 6; */
        for (let i = 0; i < message.fileIds.length; i++)
            writer.tag(6, WireType.LengthDelimited).string(message.fileIds[i]);
        /* string container_id = 7; */
        if (message.containerId !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.containerId);
        /* google.protobuf.Timestamp container_expires_at = 8; */
        if (message.containerExpiresAt)
            Timestamp.internalBinaryWrite(message.containerExpiresAt, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* string mcp_server_name = 9; */
        if (message.mcpServerName !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.mcpServerName);
        /* bool is_error = 10; */
        if (message.isError !== false)
            writer.tag(10, WireType.Varint).bool(message.isError);
        /* rd.llm.Usage usage = 11; */
        if (message.usage)
            Usage.internalBinaryWrite(message.usage, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* string caller_tool_request_id = 12; */
        if (message.callerToolRequestId !== "")
            writer.tag(12, WireType.LengthDelimited).string(message.callerToolRequestId);
        /* rd.llm.StopReason stop_reason = 13; */
        if (message.stopReason !== 0)
            writer.tag(13, WireType.Varint).int32(message.stopReason);
        /* string signature = 14; */
        if (message.signature !== "")
            writer.tag(14, WireType.LengthDelimited).string(message.signature);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.llm.Fragment
 */
export const Fragment = new Fragment$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserAppContext$Type extends MessageType<UserAppContext> {
    constructor() {
        super("rd.llm.UserAppContext", [
            { no: 1, name: "route_history", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "location_id", kind: "message", T: () => UUID },
            { no: 3, name: "feature", kind: "message", T: () => UserAppContext_Feature }
        ]);
    }
    create(value?: PartialMessage<UserAppContext>): UserAppContext {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.routeHistory = [];
        if (value !== undefined)
            reflectionMergePartial<UserAppContext>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UserAppContext): UserAppContext {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated string route_history */ 1:
                    message.routeHistory.push(reader.string());
                    break;
                case /* rd.proto.uuid.UUID location_id */ 2:
                    message.locationId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.locationId);
                    break;
                case /* rd.llm.UserAppContext.Feature feature */ 3:
                    message.feature = UserAppContext_Feature.internalBinaryRead(reader, reader.uint32(), options, message.feature);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UserAppContext, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated string route_history = 1; */
        for (let i = 0; i < message.routeHistory.length; i++)
            writer.tag(1, WireType.LengthDelimited).string(message.routeHistory[i]);
        /* rd.proto.uuid.UUID location_id = 2; */
        if (message.locationId)
            UUID.internalBinaryWrite(message.locationId, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.llm.UserAppContext.Feature feature = 3; */
        if (message.feature)
            UserAppContext_Feature.internalBinaryWrite(message.feature, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.llm.UserAppContext
 */
export const UserAppContext = new UserAppContext$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserAppContext_Feature$Type extends MessageType<UserAppContext_Feature> {
    constructor() {
        super("rd.llm.UserAppContext.Feature", [
            { no: 1, name: "type", kind: "enum", T: () => ["rd.llm.UserAppContext.Feature.Type", UserAppContext_Feature_Type, "TYPE_"] },
            { no: 2, name: "customer_chat", kind: "message", T: () => UserAppContext_Feature_CustomerChat }
        ]);
    }
    create(value?: PartialMessage<UserAppContext_Feature>): UserAppContext_Feature {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.type = 0;
        if (value !== undefined)
            reflectionMergePartial<UserAppContext_Feature>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UserAppContext_Feature): UserAppContext_Feature {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.llm.UserAppContext.Feature.Type type */ 1:
                    message.type = reader.int32();
                    break;
                case /* rd.llm.UserAppContext.Feature.CustomerChat customer_chat */ 2:
                    message.customerChat = UserAppContext_Feature_CustomerChat.internalBinaryRead(reader, reader.uint32(), options, message.customerChat);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UserAppContext_Feature, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.llm.UserAppContext.Feature.Type type = 1; */
        if (message.type !== 0)
            writer.tag(1, WireType.Varint).int32(message.type);
        /* rd.llm.UserAppContext.Feature.CustomerChat customer_chat = 2; */
        if (message.customerChat)
            UserAppContext_Feature_CustomerChat.internalBinaryWrite(message.customerChat, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.llm.UserAppContext.Feature
 */
export const UserAppContext_Feature = new UserAppContext_Feature$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserAppContext_Feature_CustomerChat$Type extends MessageType<UserAppContext_Feature_CustomerChat> {
    constructor() {
        super("rd.llm.UserAppContext.Feature.CustomerChat", [
            { no: 1, name: "composer_value", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<UserAppContext_Feature_CustomerChat>): UserAppContext_Feature_CustomerChat {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.composerValue = "";
        if (value !== undefined)
            reflectionMergePartial<UserAppContext_Feature_CustomerChat>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UserAppContext_Feature_CustomerChat): UserAppContext_Feature_CustomerChat {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string composer_value */ 1:
                    message.composerValue = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UserAppContext_Feature_CustomerChat, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string composer_value = 1; */
        if (message.composerValue !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.composerValue);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.llm.UserAppContext.Feature.CustomerChat
 */
export const UserAppContext_Feature_CustomerChat = new UserAppContext_Feature_CustomerChat$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DailySummaryNotificationCopy$Type extends MessageType<DailySummaryNotificationCopy> {
    constructor() {
        super("rd.llm.DailySummaryNotificationCopy", [
            { no: 1, name: "subject", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.proto.schema.desc_f": "Concise notification subject line that captures the most important highlight or theme from today's business summary. Always starts with 'Dooey daily: ' prefix. Maximum 60 characters total (including prefix). No emojis or special formatting.", "rd.proto.schema.required": true } },
            { no: 2, name: "content", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.proto.schema.desc_f": "Brief notification message summarizing key highlights from today's business report. Written as a single paragraph in complete, grammatically correct sentences. No line breaks, URLs, links, or action text. Includes 2-3 of the most important points. Maximum 250 characters. Plain text with no markdown or special formatting.", "rd.proto.schema.required": true } }
        ], { "rd.proto.schema.desc_m": "Notification copy for daily summary, containing both subject and content" });
    }
    create(value?: PartialMessage<DailySummaryNotificationCopy>): DailySummaryNotificationCopy {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.subject = "";
        message.content = "";
        if (value !== undefined)
            reflectionMergePartial<DailySummaryNotificationCopy>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DailySummaryNotificationCopy): DailySummaryNotificationCopy {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string subject */ 1:
                    message.subject = reader.string();
                    break;
                case /* string content */ 2:
                    message.content = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DailySummaryNotificationCopy, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string subject = 1; */
        if (message.subject !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.subject);
        /* string content = 2; */
        if (message.content !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.content);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.llm.DailySummaryNotificationCopy
 */
export const DailySummaryNotificationCopy = new DailySummaryNotificationCopy$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RoutineNotificationCopy$Type extends MessageType<RoutineNotificationCopy> {
    constructor() {
        super("rd.llm.RoutineNotificationCopy", [
            { no: 1, name: "subject", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.proto.schema.desc_f": "Concise notification subject line that captures the most important highlight or theme from the routine's output. Always starts with 'Dooey: ' prefix. Maximum 60 characters total (including prefix). No emojis or special formatting.", "rd.proto.schema.required": true } },
            { no: 2, name: "content", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.proto.schema.desc_f": "Brief notification message summarizing the key output from the routine run. Written as a single paragraph in complete, grammatically correct sentences. No line breaks, URLs, links, or action text. Includes 2-3 of the most important points. Maximum 250 characters. Plain text with no markdown or special formatting.", "rd.proto.schema.required": true } }
        ], { "rd.proto.schema.desc_m": "Notification copy for a routine run, containing both subject and content" });
    }
    create(value?: PartialMessage<RoutineNotificationCopy>): RoutineNotificationCopy {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.subject = "";
        message.content = "";
        if (value !== undefined)
            reflectionMergePartial<RoutineNotificationCopy>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RoutineNotificationCopy): RoutineNotificationCopy {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string subject */ 1:
                    message.subject = reader.string();
                    break;
                case /* string content */ 2:
                    message.content = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RoutineNotificationCopy, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string subject = 1; */
        if (message.subject !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.subject);
        /* string content = 2; */
        if (message.content !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.content);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.llm.RoutineNotificationCopy
 */
export const RoutineNotificationCopy = new RoutineNotificationCopy$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Memory$Type extends MessageType<Memory> {
    constructor() {
        super("rd.llm.Memory", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 3, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 4, name: "last_used", kind: "message", T: () => Timestamp },
            { no: 5, name: "company_id", kind: "message", T: () => UUID },
            { no: 6, name: "user_id", kind: "message", T: () => UUID },
            { no: 7, name: "path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "content", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "parent_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "type", kind: "enum", T: () => ["rd.llm.Memory.Type", Memory_Type, "TYPE_"] }
        ]);
    }
    create(value?: PartialMessage<Memory>): Memory {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.path = "";
        message.content = [];
        message.parentPath = "";
        message.type = 0;
        if (value !== undefined)
            reflectionMergePartial<Memory>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Memory): Memory {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* google.protobuf.Timestamp created_at */ 2:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 3:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* google.protobuf.Timestamp last_used */ 4:
                    message.lastUsed = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.lastUsed);
                    break;
                case /* rd.proto.uuid.UUID company_id */ 5:
                    message.companyId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.companyId);
                    break;
                case /* rd.proto.uuid.UUID user_id */ 6:
                    message.userId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.userId);
                    break;
                case /* string path */ 7:
                    message.path = reader.string();
                    break;
                case /* repeated string content */ 8:
                    message.content.push(reader.string());
                    break;
                case /* string parent_path */ 9:
                    message.parentPath = reader.string();
                    break;
                case /* rd.llm.Memory.Type type */ 10:
                    message.type = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Memory, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp created_at = 2; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 3; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp last_used = 4; */
        if (message.lastUsed)
            Timestamp.internalBinaryWrite(message.lastUsed, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID company_id = 5; */
        if (message.companyId)
            UUID.internalBinaryWrite(message.companyId, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID user_id = 6; */
        if (message.userId)
            UUID.internalBinaryWrite(message.userId, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* string path = 7; */
        if (message.path !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.path);
        /* repeated string content = 8; */
        for (let i = 0; i < message.content.length; i++)
            writer.tag(8, WireType.LengthDelimited).string(message.content[i]);
        /* string parent_path = 9; */
        if (message.parentPath !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.parentPath);
        /* rd.llm.Memory.Type type = 10; */
        if (message.type !== 0)
            writer.tag(10, WireType.Varint).int32(message.type);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.llm.Memory
 */
export const Memory = new Memory$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CronScheduleOutput$Type extends MessageType<CronScheduleOutput> {
    constructor() {
        super("rd.llm.CronScheduleOutput", [
            { no: 1, name: "cron_expression", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.proto.schema.desc_f": "A valid 5-field cron expression in the format 'minute hour day-of-month month day-of-week'. Examples: '0 9 * * 1-5' for weekdays at 9am, '30 14 1 * *' for the 1st of every month at 2:30pm.", "rd.proto.schema.required": true } }
        ], { "rd.proto.schema.desc_m": "A 5-field cron expression (minute hour day-of-month month day-of-week)" });
    }
    create(value?: PartialMessage<CronScheduleOutput>): CronScheduleOutput {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.cronExpression = "";
        if (value !== undefined)
            reflectionMergePartial<CronScheduleOutput>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CronScheduleOutput): CronScheduleOutput {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string cron_expression */ 1:
                    message.cronExpression = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CronScheduleOutput, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string cron_expression = 1; */
        if (message.cronExpression !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.cronExpression);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.llm.CronScheduleOutput
 */
export const CronScheduleOutput = new CronScheduleOutput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CategoryIconNameOutput$Type extends MessageType<CategoryIconNameOutput> {
    constructor() {
        super("rd.llm.CategoryIconNameOutput", [
            { no: 1, name: "icon_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.proto.schema.desc_f": "A valid kebab-case Lucide icon name, or empty string if no good match exists. Only return names that exist in the Lucide icon library. Examples: 'paint-bucket', 'hammer', 'wrench', 'lightbulb'." } }
        ]);
    }
    create(value?: PartialMessage<CategoryIconNameOutput>): CategoryIconNameOutput {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.iconName = "";
        if (value !== undefined)
            reflectionMergePartial<CategoryIconNameOutput>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CategoryIconNameOutput): CategoryIconNameOutput {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string icon_name */ 1:
                    message.iconName = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CategoryIconNameOutput, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string icon_name = 1; */
        if (message.iconName !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.iconName);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.llm.CategoryIconNameOutput
 */
export const CategoryIconNameOutput = new CategoryIconNameOutput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PriceSuggestionOutput$Type extends MessageType<PriceSuggestionOutput> {
    constructor() {
        super("rd.llm.PriceSuggestionOutput", [
            { no: 1, name: "suggested_price_cents", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "rd.proto.schema.desc_f": "The suggested retail price in cents (USD). For example, $1.99 should be 199.", "rd.proto.schema.required": true } }
        ]);
    }
    create(value?: PartialMessage<PriceSuggestionOutput>): PriceSuggestionOutput {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.suggestedPriceCents = 0;
        if (value !== undefined)
            reflectionMergePartial<PriceSuggestionOutput>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PriceSuggestionOutput): PriceSuggestionOutput {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 suggested_price_cents */ 1:
                    message.suggestedPriceCents = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PriceSuggestionOutput, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 suggested_price_cents = 1; */
        if (message.suggestedPriceCents !== 0)
            writer.tag(1, WireType.Varint).int32(message.suggestedPriceCents);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.llm.PriceSuggestionOutput
 */
export const PriceSuggestionOutput = new PriceSuggestionOutput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Routine$Type extends MessageType<Routine> {
    constructor() {
        super("rd.llm.Routine", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 3, name: "company_id", kind: "message", T: () => UUID },
            { no: 4, name: "type", kind: "enum", T: () => ["rd.llm.Routine.Type", Routine_Type, "TYPE_"] },
            { no: 5, name: "user_prompt", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "last_run_at", kind: "message", T: () => Timestamp },
            { no: 7, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 8, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 9, name: "is_active", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 10, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "scheduled_run_time", kind: "message", T: () => Timestamp },
            { no: 12, name: "cron_schedule_prompt", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 13, name: "cron_schedule", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 14, name: "staff_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID }
        ]);
    }
    create(value?: PartialMessage<Routine>): Routine {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.type = 0;
        message.userPrompt = "";
        message.isActive = false;
        message.name = "";
        message.cronSchedulePrompt = "";
        message.cronSchedule = "";
        message.staffIds = [];
        if (value !== undefined)
            reflectionMergePartial<Routine>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Routine): Routine {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* rd.proto.uuid.UUID company_id */ 3:
                    message.companyId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.companyId);
                    break;
                case /* rd.llm.Routine.Type type */ 4:
                    message.type = reader.int32();
                    break;
                case /* string user_prompt */ 5:
                    message.userPrompt = reader.string();
                    break;
                case /* google.protobuf.Timestamp last_run_at */ 6:
                    message.lastRunAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.lastRunAt);
                    break;
                case /* google.protobuf.Timestamp created_at */ 7:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 8:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* bool is_active */ 9:
                    message.isActive = reader.bool();
                    break;
                case /* string name */ 10:
                    message.name = reader.string();
                    break;
                case /* google.protobuf.Timestamp scheduled_run_time */ 11:
                    message.scheduledRunTime = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.scheduledRunTime);
                    break;
                case /* string cron_schedule_prompt */ 12:
                    message.cronSchedulePrompt = reader.string();
                    break;
                case /* string cron_schedule */ 13:
                    message.cronSchedule = reader.string();
                    break;
                case /* repeated rd.proto.uuid.UUID staff_ids */ 14:
                    message.staffIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Routine, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID company_id = 3; */
        if (message.companyId)
            UUID.internalBinaryWrite(message.companyId, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.llm.Routine.Type type = 4; */
        if (message.type !== 0)
            writer.tag(4, WireType.Varint).int32(message.type);
        /* string user_prompt = 5; */
        if (message.userPrompt !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.userPrompt);
        /* google.protobuf.Timestamp last_run_at = 6; */
        if (message.lastRunAt)
            Timestamp.internalBinaryWrite(message.lastRunAt, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp created_at = 7; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 8; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* bool is_active = 9; */
        if (message.isActive !== false)
            writer.tag(9, WireType.Varint).bool(message.isActive);
        /* string name = 10; */
        if (message.name !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.name);
        /* google.protobuf.Timestamp scheduled_run_time = 11; */
        if (message.scheduledRunTime)
            Timestamp.internalBinaryWrite(message.scheduledRunTime, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* string cron_schedule_prompt = 12; */
        if (message.cronSchedulePrompt !== "")
            writer.tag(12, WireType.LengthDelimited).string(message.cronSchedulePrompt);
        /* string cron_schedule = 13; */
        if (message.cronSchedule !== "")
            writer.tag(13, WireType.LengthDelimited).string(message.cronSchedule);
        /* repeated rd.proto.uuid.UUID staff_ids = 14; */
        for (let i = 0; i < message.staffIds.length; i++)
            UUID.internalBinaryWrite(message.staffIds[i], writer.tag(14, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.llm.Routine
 */
export const Routine = new Routine$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UsageTracking$Type extends MessageType<UsageTracking> {
    constructor() {
        super("rd.llm.UsageTracking", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "company_id", kind: "message", T: () => UUID },
            { no: 3, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 4, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 5, name: "expires_at", kind: "message", T: () => Timestamp },
            { no: 6, name: "usage_limit", kind: "message", T: () => Money },
            { no: 7, name: "additional_usage_limit", kind: "message", T: () => Money },
            { no: 8, name: "cumulative_usage", kind: "message", T: () => Usage }
        ]);
    }
    create(value?: PartialMessage<UsageTracking>): UsageTracking {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UsageTracking>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UsageTracking): UsageTracking {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* rd.proto.uuid.UUID company_id */ 2:
                    message.companyId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.companyId);
                    break;
                case /* google.protobuf.Timestamp created_at */ 3:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 4:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* google.protobuf.Timestamp expires_at */ 5:
                    message.expiresAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.expiresAt);
                    break;
                case /* rd.proto.money.Money usage_limit */ 6:
                    message.usageLimit = Money.internalBinaryRead(reader, reader.uint32(), options, message.usageLimit);
                    break;
                case /* rd.proto.money.Money additional_usage_limit */ 7:
                    message.additionalUsageLimit = Money.internalBinaryRead(reader, reader.uint32(), options, message.additionalUsageLimit);
                    break;
                case /* rd.llm.Usage cumulative_usage */ 8:
                    message.cumulativeUsage = Usage.internalBinaryRead(reader, reader.uint32(), options, message.cumulativeUsage);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UsageTracking, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID company_id = 2; */
        if (message.companyId)
            UUID.internalBinaryWrite(message.companyId, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp created_at = 3; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 4; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp expires_at = 5; */
        if (message.expiresAt)
            Timestamp.internalBinaryWrite(message.expiresAt, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money usage_limit = 6; */
        if (message.usageLimit)
            Money.internalBinaryWrite(message.usageLimit, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money additional_usage_limit = 7; */
        if (message.additionalUsageLimit)
            Money.internalBinaryWrite(message.additionalUsageLimit, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* rd.llm.Usage cumulative_usage = 8; */
        if (message.cumulativeUsage)
            Usage.internalBinaryWrite(message.cumulativeUsage, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.llm.UsageTracking
 */
export const UsageTracking = new UsageTracking$Type();
